/** 
 Copyright Highway9 Networks Inc. 
 */
import { Router, Route, Switch } from "react-router-dom";
import { history } from "./helpers";
import { AuthRouter } from "./navigation/AuthRouter";
import { LoginPage } from "./navigation/LoginPage";
import { theme as newTheme, ThemeProvider, ErrorBoundary } from "@h9/ui-lib";

import AppRoutes from "./navigation/AppRoutes";
import { SnackbarProvider } from "notistack";
import "./App.css";
import "./styles/flexStyles.css";

import CustomToast from "./components/Notifications/CustomToast";
import { AbilityProvider } from "~/rbac";

function App() {

  return (
    <div className="App">
      <ErrorBoundary>
        <>
          <ThemeProvider theme={newTheme}>
            <SnackbarProvider
              maxSnack={5}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              autoHideDuration={3000}
              Components={{
                default: CustomToast,
                success: CustomToast,
                error: CustomToast,
                warning: CustomToast,
                info: CustomToast,
              }}
            >
              <AbilityProvider>
                <Router history={history}>
                  <Switch>
                    <Route path="/login" component={LoginPage} />
                    <AuthRouter path="/" component={AppRoutes} />
                  </Switch>
                </Router>
              </AbilityProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </>
      </ErrorBoundary>
    </div>
  );
}

export default App;

